import { useButton as originalUseButton } from '@react-aria/button';
import { usePreventTouchEnd } from './usePreventTouchEnd';

/**
 * Thin wrapper around useButton to fix a react-aria issue on touch devices.
 * https://github.com/adobe/react-spectrum/issues/1513
 */
export const useButton: typeof originalUseButton = (props, ref) => {
  usePreventTouchEnd(ref);

  return originalUseButton(props, ref);
};
